import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthService } from '../auth.service';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  public forgotPasswordForm1: FormGroup;      // state of the confirmation form
  public forgotPasswordForm2: FormGroup;      // state of the confirmation form
  // DISPLAY POPUP CONFIRMATION
  public displayPopupConfirmOK: boolean;

  public form1visible: boolean;
  public form2visible: boolean = false;

  public username: String;


  constructor(
     private fb: FormBuilder,
     private auth: AuthService,
     private router: Router
  ) {}


  ngOnInit() {
    this.initForm();
  }

   initForm() {
      this.forgotPasswordForm1 = this.fb.group({
         'username': ['', Validators.required],
      });
      this.forgotPasswordForm2 = this.fb.group({
        'code': ['', Validators.required],
        'newPassword': ['', Validators.required]
      })
      this.form1visible = true;
   }  // end initForm


    onClickForget(value: any) {

       const username = value.username;
       this.username = username;

       if (username == ""){
         alert("Per recuperare la password inserisci prima il tuo username, poi clicca questo bottone!")
         return;
       }

       // call the confirm method of AuthService, that returns an Observable<any>
       this.auth.forgotPassword(username).subscribe(
          data => {
             // alert("CONFERMA OK");
             alert("Presto riceverai un'e-mail che ti consentirà di reimpostare la tua password. Assicurati di controllare la cartella spam e il cestino se non ricevi la nostra e-mail.");
             this.router.navigate(['/forgotPassword']);
             console.log("Successful change");
             this.form1visible = false;
             this.form2visible = true;
          },
          error => {
             alert("Username errato");
             console.log("Failed password retrieving: error = " + JSON.stringify(error, null, 2));
          }
       );

    }

   onSubmitChange(value: any) {

      const username = this.username;
      const newPassword = value.newPassword;
      const code = value.code;

      // call the confirm method of AuthService, that returns an Observable<any>
      this.auth.changeForgotPassword(username, code, newPassword).subscribe(
         data => {
            // alert("CONFERMA OK");
            this.displayPopupConfirmOK = true;
            console.log("Successful change");
         },
         error => {
            alert("Codice errato");
            console.log("Failed password changing: error = " + JSON.stringify(error, null, 2));
         }
      );

   }  // end onSubmitConfirmation

   redirectToHome() {
     this.displayPopupConfirmOK = false;
     this.router.navigate(['/home']);       // go to the login page/component
   } // end redirectToLogin

}  // end ConfirmComponent
